import { Create, Edit, SimpleForm, TextInput } from 'react-admin';
import * as React from 'react';
import { WrappedWithBackButton } from '../../common/wrapped-with-back-button';

const UniqueRequestTemplateForm = () => {
    return (
        <SimpleForm>
            <TextInput
                source="name"
                label={'Elnevezés'}
                name={'name'}
                required
                fullWidth
            />
            <TextInput
                source="content"
                label={'Tartalom'}
                name={'content'}
                required
                fullWidth
                multiline
                minRows={10}
            />
        </SimpleForm>
    );
};

export const UniqueRequestTemplateCreate = () => {
    return (
        <WrappedWithBackButton>
            <Create title={'Üzenet sablon létrehozása'} redirect={'show'}>
                <UniqueRequestTemplateForm />
            </Create>
        </WrappedWithBackButton>
    );
};

export const UniqueRequestTemplateEdit = () => {
    return (
        <WrappedWithBackButton>
            <Edit title={'Üzenet sablon szerkesztése'} redirect={'show'}>
                <UniqueRequestTemplateForm />
            </Edit>
        </WrappedWithBackButton>
    );
};
